import React from 'react';
import { useNavigate } from 'react-router-dom';
import { premiumFeatures } from '../../modules/common/constants/premium-features';
import segment from '../../modules/analytics/segment';
import DomainSelectorContainer from '../../modules/domain-selector/containers/domain-selector-container';
import useSupportedSearchParams from '../hooks/use-supported-search-params';
import routesMap from '../helpers/routes-map';
import actionIds from '../../modules/domain-selector/constants/action-ids';

const {
  constants: { triggerIds },
} = segment;

function DomainSelectorRoute() {
  const searchParams = useSupportedSearchParams();
  const navigate = useNavigate();

  if (!searchParams) return null;

  const {
    initiator,
    prefill,
    products = [],
    term,
    triggerId,
    back,
    paymentBackUrl,
    promoCampaignId,
  } = searchParams;
  const hasProducts = Boolean(products.length);

  const showPaywall = (domain) => {
    navigate(
      routesMap.paywall.url({
        query: {
          domain,
          premiumFeature: premiumFeatures.CUSTOM_DOMAIN,
          triggerId: triggerIds.DOMAIN_SELECTOR,
          actionId: actionIds.BUY_DOMAIN,
          ...(hasProducts && { products }),
          ...(paymentBackUrl && { paymentBackUrl }),
        },
      })
    );
  };

  const propsFromSearchParams = {
    ...(initiator && { initiator }),
    ...(prefill && { prefill }),
    ...(hasProducts && { extraProducts: products }),
    ...(term && { term }),
    ...(triggerId && { triggerId }),
    ...(back && { backUrl: back }),
    ...(paymentBackUrl && { paymentBackUrl }),
    ...(promoCampaignId && { promoCampaignId }),
  };

  return <DomainSelectorContainer showPaywall={showPaywall} {...propsFromSearchParams} />;
}

export default DomainSelectorRoute;
